import { render, staticRenderFns } from "./supplierTemplate.vue?vue&type=template&id=3a47bcd4&scoped=true&"
import script from "./supplierTemplate.vue?vue&type=script&lang=js&"
export * from "./supplierTemplate.vue?vue&type=script&lang=js&"
import style0 from "./supplierTemplate.vue?vue&type=style&index=0&id=3a47bcd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47bcd4",
  null
  
)

export default component.exports